<template>
    <imports-list
        :teamId="teamId"
        importType="group"
        :newImportHref="`/settings/teams/${teamId}/groups/imports/new`"
    >
        <template v-slot:title>Group Imports</template>
    </imports-list>
</template>

<script lang="ts" setup>
import ImportsList from '~/components/import/ImportsList.vue';

const teamId = Spark.state.currentTeam.id;
</script>
